import {
  QueryClientConfig,
  QueryCache,
  QueryClient,
  dehydrate,
  QueryObserverOptions,
} from '@tanstack/react-query';
import {IS_CLIENT} from '../../common/constant';

// CSR에서는 cache 가 공유되어야 하기 때문에 이 값을 사용합니다.(예: tiara 내부 사용)
let csrSharedQueryClientConfig: QueryClientConfig | undefined;

export const getReactQueryClientConfig = (): QueryClientConfig => {
  if (IS_CLIENT && csrSharedQueryClientConfig) {
    return csrSharedQueryClientConfig;
  }

  const config: QueryClientConfig = {
    defaultOptions: {
      queries: {
        networkMode: 'always',
        refetchOnWindowFocus: false,
        retry: false,
        refetchOnMount: false,
        keepPreviousData: true,
      },
      mutations: {
        networkMode: 'always',
      },
    },
    queryCache: new QueryCache(),
  };

  if (IS_CLIENT) {
    csrSharedQueryClientConfig = config;
  }
  return config;
};

export const DEHYDRATED_STATE_KEY = 'dehydratedState';

export const createQueryClient = (config?: QueryClientConfig) =>
  new QueryClient(config ?? getReactQueryClientConfig());

export const getDehydratedState = (queryClient: QueryClient) => ({
  [DEHYDRATED_STATE_KEY]: dehydrate(queryClient),
});

export const clearQueryClientInSsr = (queryClient?: QueryClient) => {
  !IS_CLIENT && queryClient?.clear();
};

/** react-query의 (cache, stale)time에 Infinity를 설정할 수 있습니다.
 *  SSR 환경에서 이 값을 stringify할 때 유효한 값이 아니라 null이 전달되기 때문에 아래와 같이 값을 추가합니다.
 *  365일은 TimeoutOverflowWarning 이 뜨고 있어 24시간으로 설정합니다 */
export const REACT_QUERY_INFINITY_TIME = 1000 * 60 * 60 * 24;

/**
 * 쿼리에 대한 캐시된 값이 있다면 캐시된 값을 사용하는 옵션입니다.
 * 이 값은 getInitialProps, getServerSideProps 등에서 getDehydrateState 를 통해 옵션도 SSR -> CSR 로 넘어갑니다
 */
export const CACHE_ONLY_CONFIG: Pick<
  QueryObserverOptions,
  'cacheTime' | 'staleTime'
> = {
  cacheTime: IS_CLIENT ? Infinity : REACT_QUERY_INFINITY_TIME,
  staleTime: IS_CLIENT ? Infinity : REACT_QUERY_INFINITY_TIME,
};
